module.exports = __webpack_public_path__ + "static/media/pongo-screen-shot.f3611ee2.webp";